function initHeroSlider() {
  var tabs = document.querySelectorAll('.tab');
  var slides = document.querySelectorAll('.slide');

  if (!tabs.length) return;

  var current = 1;

  function goToSlide(index) {
    if (index < 1) index = slides.length;
    if (index > slides.length) index = 1;

    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.remove('active');
      slides[i].classList.remove('animate');
    }

    for (var j = 0; j < tabs.length; j++) {
      tabs[j].classList.remove('active');
    }

    var activeSlide = document.querySelector('.slide[data-index="' + index + '"]');
    var activeTab = document.querySelector('.tab[data-tab="' + index + '"]');

    if (!activeSlide || !activeTab) return;

    activeSlide.classList.add('active');
    activeTab.classList.add('active');

    // RESET STATS
    var counters = activeSlide.querySelectorAll('.stat-number');
    for (var k = 0; k < counters.length; k++) {
      counters[k].innerText = "0";
    }

    // FORCE ANIMATION
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        activeSlide.classList.add('animate');

        setTimeout(function () {
          initStatsCounter(activeSlide);
        }, 200);
      });
    });

    current = index;
  }

  // TAB CLICK
  for (var t = 0; t < tabs.length; t++) {
    tabs[t].addEventListener('click', function () {
      var index = parseInt(this.getAttribute('data-tab'));
      goToSlide(index);
    });
  }

  // KEYBOARD
  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') goToSlide(current + 1);
    if (e.key === 'ArrowLeft') goToSlide(current - 1);
  });

 
  

  var startX = 0;
  var endX = 0;

  var slider = document.querySelector('.hero-slider');

  if (slider) {

    slider.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      endX = e.changedTouches[0].clientX;

      var diff = startX - endX;

      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          goToSlide(current + 1); // swipe left
        } else {
          goToSlide(current - 1); // swipe right
        }
      }

    }, { passive: true });
  }


  
  for (var x = 0; x < tabs.length; x++) {
    tabs[x].addEventListener('touchstart', function (e) {
      e.stopPropagation(); // swipe conflict remove
    });
  }


  setTimeout(function () {
    var firstSlide = document.querySelector('.slide[data-index="1"]');

    if (firstSlide) {
      firstSlide.classList.remove('active');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          goToSlide(1);
        });
      });
    }
  }, 100);
}


document.addEventListener("DOMContentLoaded", initHeroSlider);
document.addEventListener("shopify:section:load", initHeroSlider);





function initStatsCounter(scope) {
  var counters = scope.querySelectorAll('.stat-number');

  for (var i = 0; i < counters.length; i++) {
    (function (counter) {
      var target = parseInt(counter.getAttribute('data-count'));
      var count = 0;

      function update() {
        var increment = target / 80;

        if (count < target) {
          count += increment;
          counter.innerText = Math.ceil(count);
          requestAnimationFrame(update);
        } else {
          counter.innerText = formatNumber(target);
        }
      }

      update();
    })(counters[i]);
  }
}

function formatNumber(num) {
  if (num >= 1000000) return '$' + (num / 1000000).toFixed(1) + 'm +';
  if (num >= 1000) return (num / 1000).toFixed(0) + 'k +';
  return num + ' +';
}





function initSearch() {
  var openBtn = document.querySelector("#openSearch");
  var closeBtn = document.querySelector("#closeSearch");
  var overlay = document.querySelector("#searchOverlay");

  if (!openBtn || !overlay) return;

  openBtn.onclick = function (e) {
    e.preventDefault();
    overlay.classList.add("active");
  };

  if (closeBtn) {
    closeBtn.onclick = function () {
      overlay.classList.remove("active");
    };
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      overlay.classList.remove("active");
    }
  });
}

document.addEventListener("DOMContentLoaded", initSearch);
document.addEventListener("shopify:section:load", initSearch);



function initScrollReveal() {

  const elements = document.querySelectorAll(
    "h1, h2, h3, h4, h5, h6, p, .btn, img, li, .card"
  );

  elements.forEach(el => {

    if (
      el.closest(".site-header") ||
      el.closest(".hero-slider") ||
      el.closest("footer") ||
      el.closest(".hero-slider-wrapper") ||
        el.matches(".btn, a, .tab, .article-card, .article-content")

    ) return;

    el.classList.add("reveal");
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    { threshold: 0.2 }
  );

  document.querySelectorAll(".reveal").forEach(el => observer.observe(el));
}

document.addEventListener("DOMContentLoaded", initScrollReveal);
document.addEventListener("shopify:section:load", initScrollReveal);